import { useMutation } from "@tanstack/react-query";
import type { AxiosError } from "axios";

import { mutationKeyMap } from "@/features/query-client";

import { updateUserCompanySettings } from "../api";
import type { IUpdateUserCompanySettingsVariables } from "../types";

type IUpdateUserSettingsMutationResponse = Awaited<
  ReturnType<typeof updateUserCompanySettings>
>;

interface IUpdateUserSettingsMutationVariables {
  lenderCompanyId: number;
  userId: number;
  data: IUpdateUserCompanySettingsVariables;
}

export const useUpdateUserCompanySettingsMutation = () => {
  return useMutation<
    IUpdateUserSettingsMutationResponse,
    AxiosError,
    IUpdateUserSettingsMutationVariables
  >({
    mutationKey: mutationKeyMap.updateUserCompanySettings,
    mutationFn: async ({ lenderCompanyId, userId, data }) => {
      return await updateUserCompanySettings(lenderCompanyId, userId, data);
    },
  });
};
